import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Link } from '@comparethemarketau/manor-link';
import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    clickableChip: {
        width: theme.spacing[56],
        height: theme.spacing[36],
        border: `${theme.spacing.px} solid ${theme.colors.grey200}`,
        borderRadius: theme.borderRadius.sm,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    unSelected: {
        color: theme.colors.grey800
    },
    selected: {
        backgroundColor: theme.colors.primary50,
        color: theme.colors.primary500,
        fontWeight: theme.fontWeight.bold,
        border: `${theme.spacing.px} solid ${theme.colors.primary500}`
    }
}));

const ClickableChip = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { label, selected, onClick, value } = props;

    const handleClick = (e) => {
        e.preventDefault();
        if (onClick) {
            onClick(value);
        }
    };

    return (
        <div className={classNames(classes.clickableChip, selected ? classes.selected : classes.unSelected)}>
            <Link
                handleClick={handleClick}
                underline="none"
                trackingLabel={`Link for choose ${label}`}
                role={'button'}
            >
                <Typography>
                    {label}
                </Typography>
            </Link>
        </div>
    );
};

ClickableChip.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    selected: PropTypes.bool,
    onClick: PropTypes.func
};

export { ClickableChip };
